<template>
  <div id="product-customization">
    <div class="actions">
      <div class="actions-content">
        <button class="btn btn-default" type="button" @click="() => this.$emit('voltar')">
          <i class="fa fa-arrow-left" style="margin-right: 4px"></i> Voltar
        </button>
        <button class="btn btn-primary" type="button" @click="confirmar"><i class="fa fa-check" style="margin-right: 4px"></i> Confirmar</button>
      </div>
    </div>

    <div class="personalizacao-produto">
      <div class="text-center">
        <Loader v-if="loading" />
      </div>

      <div v-if="!loading" ref="products">
        <div :class="{ sticky: sticky }">
          <div class="products-header">
            <div class="opcionais">
              <div class="base-product-title">
                {{ produtoCustomizado.Descricao }}
              </div>
              <div class="actions-content">
                <button class="btn btn-default" type="button" @click="adicionarOpcionais" style="width: 270px">
                  <i class="fa fa-shopping-cart" style="margin-right: 4px"></i> Adicione componentes opcionais
                </button>
              </div>
            </div>
            <div class="produto-custom">
              <div class="produto-imagem">Imagem</div>

              <div class="produto-descricao">Descrição</div>

              <div class="produto-unidade">Un.</div>

              <div class="produto-actions">Qtde</div>

              <div class="produto-valores" style="visibility: hidden">
                <div class="produto-valor-unit">Valor Unit.</div>

                <div class="produto-valor">Valor Total</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <template v-for="(produto, index) in produtoCustomizado.Insumos">
            <template>
              <div class="product-item" v-bind:key="index">
                <ProductInput
                  :removeInsumo="removeInsumo"
                  :addQtde="addQtde"
                  :subtractQtde="subtractQtde"
                  :validarQtde="validarQtde"
                  :produto="produto"
                  :index="index"
                />
                <div v-if="produto.Associados && produto.Associados.length > 0" v-bind:key="index">
                  <template v-for="(associado, index2) in produto.Associados">
                    <template>
                      <ProductInput v-bind:key="index2" :produto="associado" :index="index" :associado="true" />
                    </template>
                  </template>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
      <OptionalProductModal :produto="produtoCustomizado" @addInsumo="(insumo) => addInsumo(insumo)"> </OptionalProductModal>
      <div class="actions actions-footer">
        <div class="actions-content">
          <div class="footer">
            <div class="panel">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-12 info">
                    <i style="margin-right: 12px" class="fa fa-calculator fa-2x"></i>
                    <span
                      >Valor do Produto: <br /><b> {{ formatDecimal(total, true) }}</b></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="panel">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-xs-12 info">
                    <i style="margin-right: 12px" class="fa fa-calculator fa-2x"></i>
                    <span>
                      Valor por kWp: <br /><b> {{ calcularWP(total) }} / Wp</b>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <button class="btn btn-primary" type="button" @click="confirmar"><i class="fa fa-check" style="margin-right: 4px"></i> Confirmar</button>
        </div>
      </div>
    </div>
    <OptionalProductModal></OptionalProductModal>
  </div>
</template>

<style type="text/css" scoped>
.panel {
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  background-color: #d8f1fe;
  color: #0d5a9d;
  margin-bottom: 0px;
  min-width: 190px;
}

.product-item {
  border-bottom: 1px solid #c4e0f7;
}

.actions {
  padding: 20px 15px;
  background: #fafafa;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
  border-radius: 4px;
}

.products-header .produto-custom {
  display: grid;
  align-items: center;
  grid-template-columns: 130px auto 45px 165px;
  border-radius: 4px;
  padding: 14px 0px;
  background: #efefef;
  border-bottom: 1px solid #c4e0f7;
  font-weight: 700;
}

.products-header .produto-custom .produto-valores {
  display: flex;
  justify-content: space-between;
}

.products-header .produto-custom .produto-imagem {
  text-align: center;
}

.products-header .produto-custom .produto-descricao {
  padding-left: 10px;
}

.products-header .produto-custom .produto-actions {
  text-align: center;
}

.products-header .produto-custom .produto-valor-unit,
.products-header .produto-custom .produto-valor {
  width: 100px;
  text-align: right;
  white-space: nowrap;
}

.products-header .produto-custom .produto-valor {
  padding-right: 10px;
}

.sticky {
  top: 40px;
  position: fixed;
  width: 100%;
  z-index: 50;
  left: 0;
}

.products-header {
  max-width: 1170px;
  margin: 0 auto;
}

.opcionais {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 15px;
  background: #005f96;
}

.actions-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.actions-content button {
  width: 120px;
}

.personalizacao-produto {
  margin-bottom: 50px;
  margin-top: 30px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  margin: 0px 10px;
  width: 65px;
}

.base-product-title {
  font-size: 18px;
  line-height: 22px;
  border-bottom: none;
  padding-bottom: 0;
  font-weight: 700;
  color: #fafafa !important;
  border-radius: 4px;
}

.btn {
  border-radius: 8px;
}

.info {
  display: flex;
  align-items: center;
}

@media (max-width: 1024px) {
  .sticky {
    top: 0px;
  }
}

@media (max-width: 600px) {
  .opcionais {
    flex-direction: column;
    gap: 16px;
  }

  .products-header .produto-custom {
    display: none;
  }

  .footer {
    flex-direction: column;
  }

  .actions-content {
    flex-direction: column;
    gap: 16px;
  }
}

.footer {
  display: flex;
  gap: 16px;
}

.actions-footer {
  margin-top: 30px;
}
</style>

<script>
import { v4 as uuidv4 } from 'uuid'
import axios from 'axios'
import OptionalProductModal from './OptionalProductModal'
import CarrinhoService from '../../../services/CarrinhoService'
import ProductInput from './ProductInput'
import swal from 'sweetalert'

export default {
  name: 'ProductCustomization',
  props: {
    codigoProduto: { type: String, default: '0' },
    codigoProjeto: { type: String, default: '0' },
    produto: { type: Object, default: null },
    eventId: { type: Number, default: 0 }
  },

  components: {
    OptionalProductModal,
    ProductInput
  },

  data() {
    return {
      loading: false,
      produtoCustomizado: {},
      valorKwp: 0,
      fullscreen: false,
      sticky: false
    }
  },

  mounted() {
    this.loading = true
    axios
      .post(`${this.$apiUrl}Produto.svc/GetProdutoPersonalizavel`, { codigoProduto: this.codigoProduto }, { withCredentials: true })
      .then((response) => {
        this.loading = false

        if (!response.data) {
          swal({
            title: 'Este produto não pode ser personalizado!',
            icon: 'warning'
          })

          this.$emit('voltar')
          return
        }

        if (this.produto) this.produtoCustomizado = this.produto
        else if (this.codigoProduto) this.loadInsumos()

        window.addEventListener('scroll', this.handleScroll)
      })
      .catch((error) => {
        console.log(error)
        swal({
          title: error,
          icon: 'error'
        })

        this.$emit('voltar')

        this.loading = false
      })
  },

  methods: {
    handleScroll() {
      const element = this.$refs.products

      if (!!element && element.getBoundingClientRect().top < 0) {
        this.sticky = true
      } else {
        this.sticky = false
      }
    },

    loadInsumos: function () {
      this.loading = true
      this.produtoCustomizado = {}

      axios
        .post(`${this.$apiUrl}Produto.svc/GetInsumoProduto`, { codigoProduto: this.codigoProduto }, { withCredentials: true })
        .then((response) => {
          if (!response.data || response.data.Insumos <= 0) {
            this.$emit('voltar')
            return
          }

          const todosInsumos = response.data.Insumos.map((x) => ({
            label: x.Descricao,
            code: x.Codigo,
            opcional: false,
            ...x
          }))

          const codigosAssociados = todosInsumos.filter((p) => p.CodigoAssociado).map((p) => p.CodigoAssociado)

          const insumos = todosInsumos
            .filter((p) => !codigosAssociados.includes(p.Codigo))
            .map((p) => {
              let associados = []

              if (codigosAssociados.includes(p.CodigoAssociado)) {
                associados = todosInsumos.filter((f) => f.Codigo === p.CodigoAssociado)
              }

              p.Associados = associados
              return p
            })

          this.produtoCustomizado = response.data
          this.produtoCustomizado.Insumos = insumos
          this.produtoCustomizado.CodigoBase = this.codigoProduto
          this.loading = false
        })
        .catch(() => {
          swal({
            title: 'Não foi possível carregar os produtos que compõem o gerador.\nPor favor, tente novamente!',
            icon: 'error'
          })

          this.$emit('voltar')

          this.loading = false
        })
    },

    subtractQtde: function (produto) {
      if (produto.Quantidade > 0) {
        produto.Quantidade -= produto.Multiplo

        this.validarQtde(produto)
      }
    },

    addQtde: async function (produto) {
      if (await this.atingiuQtdeMaxima(produto)) return

      produto.Quantidade += produto.Multiplo

      this.validarQtde(produto)
    },

    async atingiuQtdeMaxima(produto) {
      let qtdeProdutos = 0
      const limite = this.produtoCustomizado.LimitesInversor.filter((x) => x.Tipo == produto.Tipo && x.Cor == produto.Cor)[0]
      let qtdeMaxima = !limite ? await this.consultarLimiteMaximo(produto.Tipo, produto.Cor) : limite.QtdeMaxima
      if (!produto.AcessorioEstrutura)
        qtdeProdutos = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == produto.Tipo && x.Cor == produto.Cor && !x.AcessorioEstrutura).reduce(
          (acc, produto) => acc + produto.Quantidade,
          0
        )
      else qtdeProdutos = produto.Quantidade

      let div = document.createElement('div')
      div.style.textAlign = 'center'

      div.innerHTML = produto.Tipo.includes('WALLBOX') ? 'A potência do Wallbox <strong>é maior</strong> que a potência permitida pelo gerador.' : ''
      qtdeProdutos += produto.Multiplo
      if (qtdeProdutos > qtdeMaxima) {
        swal({
          title: `Quantidade máxima de ${produto.Tipo} atingida!`,
          content: div,
          icon: 'warning'
        })

        return true
      }

      return false
    },

    async consultarLimiteMaximo(tipo, cor) {
      this.loading = true

      try {
        const inversor = this.produtoCustomizado.Insumos.filter((x) => ['INVERSOR', 'MICROINVERSOR'].includes(x.Tipo))[0]
        const response = await axios.post(
          `${this.$apiUrl}Produto.svc/ValidarLimite`,
          { codigoInversor: inversor.Codigo, tipo, cor },
          { withCredentials: true }
        )
        const limites = {
          Cor: response.data.Cor,
          QtdeMaxima: response.data.QtdeMaxima * inversor.Quantidade,
          QtdeMinima: response.data.QtdeMinima,
          Tipo: response.data.Tipo
        }
        this.produtoCustomizado.LimitesInversor.push(limites)
        this.loading = false
        return limites.QtdeMaxima
      } catch (error) {
        console.log(error)
        this.loading = false
        return false
      }
    },

    async recalcularEstrutura() {
      let estrutura = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'ESTRUTURA' && !x.AcessorioEstrutura)[0]

      if (!estrutura) {
        return
      }

      const qtdePainel = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'PAINEL').reduce((acc, produto) => acc + produto.Quantidade, 0)

      const qtdeEstrutura = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'ESTRUTURA' && !x.AcessorioEstrutura).reduce(
        (acc, produto) => acc + produto.Quantidade,
        0
      )

      const razaoQuantidade = estrutura.Codigo !== 244773 ? 4 : 8

      const novaQtdeEstrutura = Math.ceil(qtdePainel / razaoQuantidade)

      if (novaQtdeEstrutura > qtdeEstrutura || novaQtdeEstrutura < qtdeEstrutura) {
        if (estrutura) {
          await swal({
            title: 'Recalcular estruturas?',
            text:
              novaQtdeEstrutura > qtdeEstrutura
                ? 'Quantidade de estruturas menor do que o necessário.'
                : 'Quantidade de estruturas maior do que o necessário.',
            icon: 'warning',
            buttons: ['Não', 'Recalcular'],
            dangerMode: true
          }).then((recalc) => {
            if (recalc) {
              const qtdeEstruturasOpcionais = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'ESTRUTURA')
                .filter((x) => x.Codigo !== estrutura.Codigo)
                .filter((x) => !x.AcessorioEstrutura)
                .reduce((acc, produto) => acc + produto.Quantidade, 0)

              estrutura.Quantidade = novaQtdeEstrutura - qtdeEstruturasOpcionais
              if (estrutura.Quantidade < 0) {
                estrutura.Quantidade = 0
              }

              if (qtdeEstruturasOpcionais > 0) {
                let div = document.createElement('div')
                div.style.textAlign = 'left'

                const html = [
                  'A quantidade de itens na estrututa principal ',
                  '<b>' + estrutura.Descricao + '</b>',
                  ' foi alterada para ',
                  estrutura.Quantidade,
                  ' devido a quantidade de estruturas adicionais. Certifique-se de que a quantidade atende aos requisitos de projeto.'
                ]

                div.innerHTML = html.join('')

                swal({
                  title: 'Quantidade de itens alterados',
                  content: div,
                  icon: 'warning'
                })
              }

              this.calcularValor(estrutura)
              this.normalizeAssociation(estrutura)
            }
          })
        }
      }
    },

    async recalcularMicroInversor() {
      const microInversores = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'MICROINVERSOR')

      if (microInversores.length > 0) {
        const qtdePainel = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'PAINEL').reduce((acc, produto) => acc + produto.Quantidade, 0)

        let microinversor = microInversores[0]

        const razaoQuantidade = microinversor.Codigo === 206204 ? 2 : 4

        const qtdeMicroInversor = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'MICROINVERSOR').reduce(
          (acc, produto) => acc + produto.Quantidade,
          0
        )

        const novaQtdeMicroInversor = Math.ceil(qtdePainel / razaoQuantidade)

        if (novaQtdeMicroInversor > qtdeMicroInversor || novaQtdeMicroInversor < qtdeMicroInversor) {
          let microinversor = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'MICROINVERSOR')[0]

          const qtdeMicroInversoresOpcionais = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == 'MICROINVERSOR')
            .filter((x) => x.Codigo !== microinversor.Codigo)
            .reduce((acc, produto) => acc + produto.Quantidade, 0)

          microinversor.Quantidade = novaQtdeMicroInversor - qtdeMicroInversoresOpcionais
          this.calcularValor(microinversor)
          this.normalizeAssociation(microinversor, true)
        }
      }
    },

    normalizeAssociation: function (produto, isMicroInversor = false) {
      const self = this

      if (produto.Associados && produto.Associados.length > 0) {
        axios
          .get(`${self.$apiUrl}Produto.svc/getMicroInversorRazaoConector1x1`)
          .then(function (response) {
            const microInversoresRazao1x1 = Array.isArray(response.data) ? response.data : []

            produto.Associados.forEach(function (f) {
              if (!isMicroInversor && f.Tipo !== 'CONECTOR') {
                f.Quantidade = produto.Quantidade
              } else {
                const razaoInversorConector = microInversoresRazao1x1.includes(produto.Codigo.toString()) ? 1 : 3
                let qtde = Math.floor(produto.Quantidade / razaoInversorConector)

                if (produto.Quantidade % razaoInversorConector !== 0) {
                  qtde += 1
                }

                f.Quantidade = qtde
              }

              self.calcularValor(f)
            })
          })
          .catch(function (error) {
            console.error('Erro ao buscar razão do microinversor:', error)
          })
      }
    },

    removeInsumo(produto) {
      const index = this.produtoCustomizado.Insumos.findIndex((x) => x.Codigo == produto.Codigo)

      if (index != -1) {
        this.produtoCustomizado.Insumos.splice(index, 1)
      }
    },

    removeProduct(id, goToStart = true) {
      this.$emit('removeProduct', { id, goToStart })
    },

    async addInsumo({ insumo, novosCabos }) {
      if (await this.atingiuQtdeMaxima(insumo)) return

      if (novosCabos.length > 0) {
        const cabosAtuais = this.produtoCustomizado.Insumos.filter((f) => f.Tipo === 'CABO SOLAR' && !f.opcional).map((m) => m.Codigo)

        if (cabosAtuais.length > 0) {
          this.produtoCustomizado.Insumos = this.produtoCustomizado.Insumos.filter((f) => !cabosAtuais.includes(f.Codigo))

          novosCabos.forEach((f) => {
            f.opcional = false
            this.produtoCustomizado.Insumos.push(f)
          })
        } else {
          this.produtoCustomizado.Insumos.push(insumo)
        }
      } else {
        this.produtoCustomizado.Insumos.push(insumo)
      }

      swal({
        title: 'Produto adicionado com sucesso!',
        icon: 'success'
      })
    },

    validarQtde: async function (produto) {
      produto.Quantidade = parseInt(produto.Quantidade)
      const fator = parseInt(produto.Quantidade / produto.Multiplo)
      const resto = produto.Quantidade % produto.Multiplo

      if (resto > 0) produto.Quantidade = produto.Multiplo * (fator + 1)

      let qtdeOutrosInsumosMesmoTipo = 0

      if (!produto.AcessorioEstrutura)
        qtdeOutrosInsumosMesmoTipo = this.produtoCustomizado.Insumos.filter((x) => x.Tipo == produto.Tipo && x.Cor == produto.Cor)
          .filter((x) => x.Codigo !== produto.Codigo)
          .filter((x) => !x.AcessorioEstrutura)
          .reduce((acc, produto) => acc + produto.Quantidade, 0)

      if (produto.Quantidade < produto.Limites.QtdeMinima) {
        produto.Quantidade = produto.Limites.QtdeMinima
      } else if (qtdeOutrosInsumosMesmoTipo + parseInt(produto.Quantidade) > produto.Limites.QtdeMaxima) {
        produto.Quantidade = produto.Limites.QtdeMaxima - qtdeOutrosInsumosMesmoTipo
      }

      if (produto.Tipo == 'PAINEL') {
        await this.recalcularEstrutura(produto)
        await this.recalcularMicroInversor(produto)
      }
      this.calcularValor(produto)
      this.normalizeAssociation(produto)
    },

    openCart: function () {
      const self = this
      var isVendaDireta = localStorage.getItem('GetTipoPedido').includes('DIRETA')

      if (isVendaDireta) {
        location.href = `${self.$SiteUrl}/loja/meu-carrinho-venda-direta/carrinho`
      } else {
        location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`
      }
    },

    formatDecimal: function (v, currency = false, casasDecimais = 2) {
      if (!currency) {
        return parseFloat(v).toLocaleString('pt-BR', {
          minimumFractionDigits: casasDecimais,
          maximumFractionDigits: casasDecimais,
          style: 'decimal'
        })
      }
      return parseFloat(v).toLocaleString('pt-BR', {
        minimumFractionDigits: casasDecimais,
        maximumFractionDigits: casasDecimais,
        style: 'currency',
        currency: 'BRL'
      })
    },

    calcularValor: function (produto) {
      const valor = produto.Quantidade * Number(produto.ValorUnitario.toFixed(3))
      produto.ValorFormatado = this.formatDecimal(valor)
      produto.Valor = valor
    },

    confirmar: function () {
      const valorTotal = Math.round(this.total * 100) / 100

      if (!this.produtoCustomizado.id) {
        this.produtoCustomizado = {
          id: uuidv4(),
          qtde: 1,
          valor: valorTotal,
          mostrarInsumos: false,
          ...this.produtoCustomizado
        }
      }

      this.produtoCustomizado.Preco = valorTotal
      this.produtoCustomizado.valor = valorTotal
      this.produtoCustomizado.CodigoBase = this.codigoProduto

      this.loading = true

      const produto = {
        Codigo: this.produtoCustomizado.Codigo,
        CodigoBase: this.produtoCustomizado.CodigoBase,
        Descricao: '',
        Imagem: '',
        Insumos: CarrinhoService.NormalizarInsumos(this.produtoCustomizado.Insumos),
        Quantidade: this.produtoCustomizado.Quantidade,
        Preco: this.produtoCustomizado.valor,
        LinkFolheto: this.produtoCustomizado.LinkFolheto,
        Disponibilidade: this.produtoCustomizado.Disponibilidade
      }

      this.$emit('addProduct', this.produtoCustomizado)
    },

    adicionarOpcionais: function () {
      $('#optional-product-modal').modal({ backdrop: 'static', keyboard: false })
    },

    calcularWP: function (valor) {
      if (!(this.produtoCustomizado.hasOwnProperty('Insumos') && this.produtoCustomizado.Insumos.length > 0)) return 0

      const valorKwp = valor / (this.valorPotencia * 1000)
      this.produtoCustomizado.Descricao = this.mostrarDescricaoComPotenciaCalculada(this.produtoCustomizado.Descricao)
      return this.formatDecimal(valorKwp, false)
    },

    mostrarDescricaoComPotenciaCalculada: function (descricao) {
      if (!descricao) return ''

      const regex = /(GF )(\d+,\d+)(KWP)/
      const potenciaFormatada = this.formatDecimal(this.valorPotencia, false, 2)
      const novaDescricao = descricao.replace(regex, `$1${potenciaFormatada}$3`)
      return novaDescricao
    }
  },

  watch: {
    eventId: function () {
      if (!this.produto) this.loadInsumos()
    },

    produto: function () {
      if (this.produto) this.produtoCustomizado = this.produto
    }
  },

  computed: {
    total: function () {
      if (!(this.produtoCustomizado.hasOwnProperty('Insumos') && this.produtoCustomizado.Insumos.length > 0)) return 0

      const valor = this.produtoCustomizado.Insumos.reduce((acc, obj) => {
        return acc + Number(obj.ValorUnitario.toFixed(3)) * obj.Quantidade
      }, 0)

      const valorAssociados = this.produtoCustomizado.Insumos.filter((f) => f.Associados && f.Associados.length > 0).reduce(
        (acc, obj) =>
          acc +
          obj.Associados.reduce((acc2, obj2) => {
            return acc2 + Number(obj2.ValorUnitario.toFixed(3)) * obj2.Quantidade
          }, 0),
        0
      )

      return valor + valorAssociados + 0.01
    },
    valorPotencia: function () {
      if (!(this.produtoCustomizado.hasOwnProperty('Insumos') && this.produtoCustomizado.Insumos.length > 0)) return 0

      const valorpotencia = this.produtoCustomizado.Insumos.reduce((acc, obj) => {
        return obj.Potencia > 0 ? parseFloat(acc + obj.Potencia * obj.Quantidade) : acc
      }, 0)

      return valorpotencia
    }
  }
}
</script>
